import axios from '@/plugins/axios'
import { MessageBox, Message } from 'element-ui'

export default {
  namespaced: true,

  state: {
    loading: false,
    data: [],
    page: 1,
    page_size: 10,
    order_column: 'created_at',
    order_type: 'desc'
  },

  mutations: {
    setData(state, payload) {
      state.data = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    }
  },

  actions: {
    read({ commit, state }, filters = null) {
      commit('setLoading', true)
      axios.admin
        .get('vc/paypal', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...filters
          }
        })
        .then(r => {
          commit('setData', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    paid({ dispatch }, payload) {
      MessageBox.confirm(
        `You will mark this request as paid. Continue?`,
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          axios.admin
            .put(`vc/paypal/${payload.id}/paid`, {
              user_id: payload.user_id,
              paid_amount: payload.amount
            })
            .then(() => {
              dispatch('read')
            })
        })
        .catch(() => {
          Message({
            type: 'info',
            message: 'Cancelled'
          })
        })
    }
  }
}
